import { ObservableArray, View } from "binder"
import { ReceiveCartableDetailViewModel, ReceiveCartableItem } from "./receiveCartableDetail-viewModel"

export class ReceiveCartableDetailView extends View<ReceiveCartableDetailViewModel>{
    GetViewUniqueId(): string {
        return "V-C01B9723-CFA2-464E-8CC9-2183A97F98FD"
    }
    loadHtml(): string {
        let element = require('./receiveCartableDetail.html').default;
        let style = require('./receiveCartableDetail.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set receiveCartableItems(v: ObservableArray<ReceiveCartableItem>) { this._receiveCartableItems = v; } public get receiveCartableItems(): ObservableArray<ReceiveCartableItem> { return this._receiveCartableItems; } private _receiveCartableItems: ObservableArray<ReceiveCartableItem>;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId;} private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName;} private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId;} private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName;} private _toWarehouseName: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set receiveTime(v: moment.Moment) { this._receiveTime = v; } public get receiveTime(): moment.Moment { return this._receiveTime;} private _receiveTime: moment.Moment;
    public set sentTime(v: moment.Moment) { this._sentTime = v; } public get sentTime(): moment.Moment { return this._sentTime;} private _sentTime: moment.Moment;
    public set sendNumber(v: string) { this._sendNumber = v; } public get sendNumber(): string { return this._sendNumber;} private _sendNumber: string;
    public set sendPackageState(v: number) { this._sendPackageState = v; } public get sendPackageState(): number { return this._sendPackageState;} private _sendPackageState: number;
    public set canReceive(v: boolean) { this._canReceive = v; } public get canReceive(): boolean { return this._canReceive;} private _canReceive: boolean;
    public set driverName(v: string) { this._driverName = v; } public get driverName(): string { return this._driverName;} private _driverName: string;
    public set carNumber(v: string) { this._carNumber = v; } public get carNumber(): string { return this._carNumber;} private _carNumber: string;
    public set sendPackageId(v: string) { this._sendPackageId = v; } public get sendPackageId(): string { return this._sendPackageId;} private _sendPackageId: string;
    
    close() {
        this.dataContext.close();
    }

    receive() {
        this.dataContext.receive();
    }

    public print() {
        this.dataContext.print();
    }
}
